export async function copyHelper(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error("Could not copy text: ", err);
  }
};
